import React from "react";
import ReactPlayer from "react-player/youtube";

export default function YouTubeComponent({ value }) {
  const { url } = value;

  return (
    <div className="relative pt-[51.75%]">
      <ReactPlayer
        url={url}
        width="100%"
        height="100%"
        className="absolute top-0 left-0"
      />
    </div>
  );
}
